module.exports = __webpack_public_path__ + "static/img/son4.9137e1b2.png";